export const formatPrice = (val: number): string => {
  return new Intl.NumberFormat('zh-CN', { style: 'currency', currency: 'CNY' }).format(val).replace(/^(\D+)/, '$1 ');
};

export const formatWeight = (val: number, suffix: string): string => {
  // TODO: once implemented in all major browsers, bring back this cool way: return new Intl.NumberFormat('zh-CN', { style: 'unit', unit: 'kilogram', unitDisplay: 'short' }).format(val / 1000);
  const weight = new Intl.NumberFormat('zh-CN').format(val / 1000);
  return `${weight} ${suffix}`;
};
